import { OutlinedInput, Typography, FormControl, FormHelperText, IconButton, Chip, Box, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { Controller } from 'react-hook-form';

function CustomInput({ control, name, formLabel, description, isPhoneNumber, disabled, optional = false, noPadding = false, ...props }) {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <FormControl error={fieldState.invalid} style={{ paddingBottom: noPadding ? 0 : '8px' }}>
                    {formLabel && (
                        <Box display="flex" gap={2} alignItems="center">
                            <Typography style={{ paddingBottom: description ? 0 : '4px', fontWeight: 700, color: '#666' }}>
                                {formLabel}
                            </Typography>
                            {optional && (
                                <Chip
                                    label="任意"
                                    size="small"
                                    style={{ borderRadius: '4px', height: '18px', fontSize: '12px', paddingTop: 2 }}
                                />
                            )}
                        </Box>
                    )}
                    {description && <Typography variant="caption">{description}</Typography>}
                    <OutlinedInput
                        id={name}
                        {...field}
                        {...props}
                        disabled={disabled}
                        sx={{
                            paddingRight: 0,
                            fontSize: 16,
                            '& input:-webkit-autofill': {
                                WebkitBoxShadow: '0 0 0 100px #E8F0FE inset',
                                WebkitTextFillColor: 'inherit'
                            }
                        }}
                        name={name}
                        value={field.value || ''}
                        onChange={(e) => {
                            field.onChange(e);
                            if (props.onChange != null) {
                                props.onChange(e);
                            }
                        }}
                        onBlur={(e) => {
                            field.onBlur();
                            if (props.onBlur != null) {
                                props.onBlur(e);
                            }
                        }}
                        startAdornment={isPhoneNumber ? <InputAdornment position="start">+81</InputAdornment> : null}
                        endAdornment={
                            !props.readOnly && field.value && !disabled ? (
                                <IconButton
                                    sx={{ width: 48, justifyContent: 'center', m: 0 }}
                                    onClick={() => {
                                        field.onChange('');
                                        if (props.onChange != null) {
                                            props.onChange({ target: { value: '' } });
                                        }
                                        if (props.onBlur != null) {
                                            props.onBlur({ target: { value: '' } });
                                        }
                                    }}
                                >
                                    <ClearIcon />
                                </IconButton>
                            ) : null
                        }
                    />
                    <FormHelperText style={{ margin: '3px 0 0 0', whiteSpace: 'pre-line' }}>{fieldState.error?.message}</FormHelperText>
                </FormControl>
            )}
        />
    );
}

export default CustomInput;
